<sbe-profile-menu [user]="user()" (logoutRequested)="logoutRequested.emit()">
  <ng-container profileMenuSection>
    <mat-divider />
    <a mat-menu-item routerLink="/consents">
      <mat-icon matMenuItemIcon>link</mat-icon>
      연동 관리
    </a>
  </ng-container>
</sbe-profile-menu>
